import { PermissionLevel } from 'src/types/profilePermission';
import { SystemModules } from 'src/types/systemModules';

export type SystemClaimPermission = {
  [key in SystemModules]: PermissionLevel;
};

export enum UserProfilesNames {
  Admin = 'Administrador del sistema', //Administrador del sistema-GO-COMPLIANCE-WEB
  Administrativo = 'Administrativo', //Administrativo-GO-COMPLIANCE-WEB
  Conductor = 'Conductor', //Conductor-GO-COMPLIANCE-WEB
  Inspector = 'Inspector', //Inspector-GO-COMPLIANCE-WEB
}
